import { ActionsJobs } from "../../../Actions/ActionsJobs/ActionsJobs";

export const onCreateCampaignBasedOnJob = (jobId) => {
  ActionsJobs.createCampaignBasedOnJob(jobId);

  const createCampaignBasedOnJobCompleted = ActionsJobs.createCampaignBasedOnJob.completed.listen(
    ({ payload }) => {
      const { job } = payload;
      if (job.campaignLink) {
        window.location.href = job.campaignLink;
      }
      createCampaignBasedOnJobCompleted();
    }
  );
};
